const short = new Map([
  ['production', 'prod'],
  ['prod', 'prod'],
  ['staging', 'test'],
  ['test', 'test'],
  ['development', 'dev'],
  ['dev', 'dev'],
  ['dev-private', 'dp'],
  ['dp', 'dp']
]);

const long = new Map([
  ['production', 'production'],
  ['prod', 'production'],
  ['staging', 'test'],
  ['test', 'test'],
  ['development', 'development'],
  ['dev', 'development'],
  ['dev-private', 'dev-private'],
  ['dp', 'dev-private']
]);

const next = new Map([
  ['production', null],
  ['prod', null],
  ['staging', 'prod'],
  ['test', 'prod'],
  ['development', 'test'],
  ['dev', 'test']
]);

const previous = new Map([
  ['production', 'test'],
  ['prod', 'test'],
  ['staging', 'dev'],
  ['test', 'dev'],
  ['development', null],
  ['dev', null]
]);

const prefix = new Map([
  ['production', ''],
  ['prod', ''],
  ['staging', 'dev-'],
  ['test', 'test-'],
  ['development', 'dev-'],
  ['dev', 'dev-'],
  ['local', 'dev-'],
  ['dev-private', 'dp-'],
  ['dp', 'dp-']
]);

const maps = { short, long, next, previous, prefix };

/**
 * Returns a environment given the destination that you want.
 *
 * @param {String} converter type of converter environment name. One of: `short`, `long`, `next`, `previous`, `prefix`
 * @returns {Function} converter of environment name
 * @throws {TypeError} If an invalid environment name is provided
 */
module.exports = function (converter) {
  if (!(converter in maps)) {
    throw new TypeError(`${converter} is not a valid environment converter`);
  }

  const envs = maps[converter];

  return function getEnv(env) {
    return envs.get(env);
  };
};
